module.exports = __webpack_public_path__ + "59bcf3fd6950d47fff5818a586ce22d6.svg";